// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3-x0w","content":"content__3Xb1-","info":"info__3Bh2d","title":"title__qf3cL","description":"description__2cXfk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/TextBreak/styles.scss
// module id = 260
// module chunks = 0